module.exports = __webpack_public_path__ + "static/media/Chosence-Light.245f864c.otf";